<template>
  <div>
    <div class="modal fade show custom-modal " id="freePackages_id" role="dialog" :class="{'modal-show':showModal}">
      <div class="modal-dialog modal-dialog-centered modal-lg" v-if="odPlanList[cardPosition] && odPlanList[cardPosition].freePackages">
        <div class="modal-content" :class="{'freeze-loader' : verifyLoaderEnabledFreePackages}">
          <div class="modal-header">
            <h5 class="modal-title ml-4 float-left font-weight-bold">Free Packages</h5>
            <div class="select-all mt-1 position-relative">
              <input
                type="checkbox"
                id="check20"
                v-model="state.isCheckAll"
                @change="checkAllFreePackages()"
                class="bgc-checkbox checkbox-position position-relative"
              >
              <label class="form-check-label" for="check20">
                <span class="pl-3">Select All</span>
              </label>
            </div>
            <button type="button" class="close" id="free-packages-cross-close" @click="addFreePackage()" :disabled="state.isAddBtnDisabledOnPackageDetailsCall">&times;</button>
          </div>
          <div class="ml-3 mr-4">
            <div class="style-border mt-1"/>
          </div>
          <div class="modal-body mt-1 pb-0">
            <div class="col-lg-12 col-md-12 col-sm-12 mr-0">
              <div class="row mt-3 mb-1  p-0">
                <div class="col-lg-6 col-md-12 col-sm-12 pt-3" v-for="(type, index) in odPlanList[cardPosition].freePackages" :key="index" >
                  <div class="pt-3 package-cover-height" :class="{'package-cover-grey': setCoverClass(index),'package-cover-dynamic-height':type.extraFields && Object.keys(type.extraFields).length>0}" >
                    <input
                      type="checkbox"
                      class="bgc-checkbox checkbox-position position-relative"
                      :id="'freepackagecheck'+' '+index"
                      v-model="type.value"
                      @change="toggleCheckbox()+callGetPackageDetails(type.value,type.packageCode,odPlanList[cardPosition],type)"
                    >
                    <label class="form-check-label" :for="'freepackagecheck'+' '+index">
                      <span class="pl-3" > {{type.packageName }}</span>
                    </label>
                    <span class="loader small inline" v-if="type.premiumLoader"
                      ><img
                        src="@/assets/images/loader.gif"
                        alt="Premium Loader"
                        class="premium-loader" />
                    </span>
                    <div class="pl-3 py-3 card shadow my-3" v-if="type.value && type.extraFields && Object.keys(type.extraFields).length>0">
                      <div class="pt-2" v-for="(param,i) in Object.keys(type.extraFields)" :key='i'>
                        <span class="mr-4"><label :for="param" class="font-weight-bold label-font-size">{{param}}</label></span>
                        <br/>
                        <select v-if='type.domainList[param]'
                          class="additional-input"
                          :id="param"
                          v-model="type.extraFields[param]"
                          :placeholder="param"
                        >
                          <option disabled value='null'>{{param}}</option>
                          <option v-for="(domain) in type.domainList[param]" :key="domain.code?domain.code:domain.name" :value='domain.code?domain.code:domain.name'>{{domain.name}}</option>
                        </select>
                        <input class="additional-input"
                          type="number"
                          v-else
                          :id="param"
                          v-model="type.extraFields[param]"
                          :placeholder="param"
                        /> 
                      </div>
                    </div> 
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ml-3 mr-4">
            <div class="style-border mt-1"/>
          </div>
          <div>
            <div class="modal-footer border-0 float-right mr-2">
              <button type="button" class="btn bgc-btn-primary button-add" id="free-packages-add" @click="addFreePackage()" :disabled="!state.isAddBtnEnabled || disableForExtraFields
               || state.isAddBtnDisabledOnPackageDetailsCall">Add</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
import { reactive,onUpdated,computed } from "@vue/composition-api";
export default {
  name: "FreePackagesModal",
  props:["odPlanList", "cardPosition", "showModal","windowWidth","initialFreePackages"],
   setup(props,context){
    let state=reactive({
      isAddBtnEnabled : false,
      isCheckAll : false,
      isAddBtnDisabledOnPackageDetailsCall : false,
      extraFieldName:''
    });
    function callGetPackageDetails(value,packageId,plan,type,isFromAllPackageSelection){
      if(value){
        state.isAddBtnDisabledOnPackageDetailsCall = true;
        context.root.$set(type,"premiumLoader",true);
        if(isFromAllPackageSelection){
          setTimeout(() => {
            context.root.$set(type,"premiumLoader",false);
            state.isAddBtnDisabledOnPackageDetailsCall = false;
          }, 5800);
        }else{
          setTimeout(() => {
            context.root.$set(type,"premiumLoader",false);
            state.isAddBtnDisabledOnPackageDetailsCall = false;
          }, 2800);
        }
        context.parent.callPackageDetailsOD(undefined, undefined, undefined,packageId,'free',plan);
      }
      else{
        type.extraFields={};
        type.domainList={};
      }
    }
    function closefreePackageModal(){
      context.parent.closefreePackageModal();
      state.isAddBtnEnabled = false;
    }
    function addFreePackage(){
      context.parent.addFreePackage(props.cardPosition);
      closefreePackageModal();
    }
    function checkAllFreePackages(){
      if(state.isCheckAll){
        props.odPlanList[props.cardPosition].freePackages.forEach(obj=>{
          if(!obj.value){
            context.root.$set(obj, 'value', true);
            callGetPackageDetails(obj.value,obj.packageCode,props.odPlanList[props.cardPosition],obj,true);
          }
        })
      }else{
        props.odPlanList[props.cardPosition].freePackages.forEach(obj=>{
          context.root.$set(obj, 'value', false);
        })
      }
      toggleCheckbox();
    }
    function isExtraFieldOD(param){
      state.extraFieldName=param ? param:'';
      if(param == "") return false;
      let keyArray = ["Cover Level Transaction Currency for Sum Insured","Cover Max Age","Discount Percentage","Further Discount Applicable","Further Discount Percentage","Loading Percentage",
      "Further Discount Max Value"];
      if(!keyArray.includes(param) && !param.includes("DomainList") && !param.includes("Tyre")) return true;
      return false;
    }
    const disableForExtraFields = computed(()=>{
      let verifyFlag = false;
      for(let i=0; i<props.odPlanList[props.cardPosition].freePackages.length; i++){
        if(props.odPlanList[props.cardPosition].freePackages[i].value){
          if(props.odPlanList[props.cardPosition].freePackages[i].extraFields && Object.keys(props.odPlanList[props.cardPosition].freePackages[i].extraFields).length>0){
            let obj= props.odPlanList[props.cardPosition].freePackages[i].extraFields;
            Object.keys(obj).forEach(ele=>{
              if(!obj[ele]){
                verifyFlag= true;
              }
            })
          }
        }
      }
      if(verifyFlag)
        return true;
      return false;
    })
    const verifyLoaderEnabledFreePackages = computed(()=>{
      let freezeFlag = false;
      if(props.odPlanList[props.cardPosition] && props.odPlanList[props.cardPosition].hasOwnProperty('freePackages') && Array.isArray(props.odPlanList[props.cardPosition].freePackages)){
        props.odPlanList[props.cardPosition].freePackages.forEach(obj=>{
          if(obj.premiumLoader){
            freezeFlag = true;
            return freezeFlag;
          }
        })
        return freezeFlag;
      }
      return freezeFlag
    })
    function setCoverClass(index){
      let flag = false;
      if(props.windowWidth.value && props.windowWidth.value>=992){
        for(let i=0;i<=index;i++){
          if(4*i+2==index || index==4*i+3){
            flag = true;
          }
        }
      }
      else{
        if(index%2 !=0){
          flag = true;
        }
      }
      return flag;
    }
    function toggleCheckbox(){
      let verifyFlag = false;
      // let allChecked = true;
      for(let i=0; i<props.odPlanList[props.cardPosition].freePackages.length; i++){
        if(props.initialFreePackages[i]!==props.odPlanList[props.cardPosition].freePackages[i].value){
          verifyFlag = true;
          break;
        }
      }
      if(verifyFlag)
        state.isAddBtnEnabled = true;
      else
        state.isAddBtnEnabled = false;
    }
    onUpdated(()=> {
      if(Array.isArray(props.odPlanList) && props.cardPosition && props.odPlanList[props.cardPosition] && props.odPlanList[props.cardPosition].hasOwnProperty('freePackages') &&
       Array.isArray(props.odPlanList[props.cardPosition].freePackages) && props.odPlanList[props.cardPosition].freePackages.length>0){
        let allChecked = true;
        let arr = props.odPlanList[props.cardPosition].freePackages.filter(obj=>{return obj.value === false });
        if(arr.length > 0){
          allChecked = false;
        }
        if(allChecked)
          state.isCheckAll = true;
        else state.isCheckAll = false;
      }
      window.addEventListener('resize',()=>{
        props.windowWidth.value = window.screen.width
      })
    });
    return{
      state,
      closefreePackageModal,
      checkAllFreePackages,
      addFreePackage,
      setCoverClass,
      disableForExtraFields,
      callGetPackageDetails,
      verifyLoaderEnabledFreePackages,
      toggleCheckbox,
      isExtraFieldOD
    }
  }
};
</script>
<style scoped>
.package-cover-grey{
  background-color: rgba(30, 30, 30, 0.1);
  height: 57px;
}
.package-cover-height{
  height: 55px;
}
.package-cover-dynamic-height{
  height: auto;
}
.label-font-size{
  font-size: 13px;
}
.additional-input{
  width: 90%;
  line-height: 33px;
  height: 33px;
  min-height: 33px;
  color: #666666;
  font-size: 12px;
  border-radius: 5%;
}
button.close {
  padding-top: 13px;
  text-align: right;
}
.button-add {
  width: 130px;
}
.freeze-loader{
  pointer-events: none;
}
.custom-modal {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  transform: scale(0);
}
.modal-show {
  display: block;
  transform: scaleY(0) scaleX(0);
  animation: unfoldIn 0.25s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
input[type="checkbox"].bgc-checkbox {
  width: 18px;
  height: 18px;
  cursor: pointer;
}
.checkbox-position {
  left: 20px;
  top: 2px;
}
.style-border {
  border-bottom: 1px solid #c7c7c7;
}
.bg-color {
  background-color: rgb(0, 0, 0, 0.05);
}
.select-all {
  left: calc(100% - 289px);
}
</style>